import React, {useCallback, useEffect} from "react";
import auth from "../../../../utils/authentication";
import {toast} from "react-toastify";
import StarsRating from "../../../shared/stars-rating/stars-rating";

import './tmdb-item-reviews.scss';
import {isHtmlEmpty, trimHtml} from "../../../../utils/utils";
import UserPost from "../../../shared/user-post/user-post";
import {SquadflixReviewsApi} from "../../../../apis/squadflix-reviews/SquadflixReviewsApi";
import {ItemReviewDTO} from "../../../../apis/chatbot/api-types";

type Props = {
    item: any; //serie or movie, never an episode
    isMovie: boolean;
}

const TmdbItemReviews = ({item, isMovie}: Props) => {

    const [reviews, setReviews] = React.useState<ItemReviewDTO[]>([]);

    const getReviews = useCallback(() => {
        if (!item?.id || !auth.currentUser) return;
        SquadflixReviewsApi.find({
            tmdb_id: item.id,
            is_movie: isMovie,
            //uid: auth.currentUser.uid,
        }).then(res => {
            setReviews(res.results ?? []);
        }).catch(e => {
            toast.error("Internal error fetching reviews");
        });
    }, [item, isMovie]);

    useEffect(() => {
        getReviews();
    }, [getReviews]);


    return (<div className="tmdb-item-reviews">
            {reviews.map((review) => (
                <UserPost key={review.id} user={review.user} postDate={review.review_date} includeTime={false}>
                    <div className="tmdb-item-reviews__content">
                        {review.episode != null && <i className="tmdb-item-reviews__date text-muted" style={{
                            fontSize: '0.9rem'
                        }}>
                            Temporada {review.season}, Episodio {review.episode}
                        </i>}
                        <div className="d-flex gap-4 flex-row mt-1">
                            <StarsRating rating={review.vote!} size={"medium"}/>
                            {review.like && <i className="fa-solid fa-heart text-danger" style={{fontSize: 20}}></i>}
                        </div>
                        {!isHtmlEmpty(review.review) &&
                            <blockquote className="tmdb-item-reviews__content-wrapper"
                                        dangerouslySetInnerHTML={{__html: trimHtml(review.review!)}}>
                            </blockquote>}
                    </div>
                </UserPost>
            ))}
        </div>
    );

}

export default TmdbItemReviews;
